export default __webpack_public_path__ + "static/media/prod3.28acd71e.png";